import type { DeliveryPoint } from '../../../interfaces/DeliveryPoint.interface';
import { type Actions, ActionType } from './delivery-points.actions';
import { deliveryPointAdapter, initialState, type State } from './delivery-points.state';

export function deliveryPointReducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionType.RESET: {
            return initialState;
        }

        case ActionType.FETCH_DELIVERY_POINTS:
            return {
                ...state,
                isPending: true
            };

        case ActionType.FETCH_DELIVERY_POINTS_SUCCEEDED: {
            return deliveryPointAdapter.setAll(action.payload.deliveryPoints, { ...state, isLoaded: true, isPending: false });
        }

        case ActionType.FETCH_DELIVERY_POINTS_FAILED: {
            return { ...state, isLoaded: false, isPending: false };
        }

        case ActionType.CREATE_DELIVERY_POINT: {
            return deliveryPointAdapter.addOne(action.payload.deliveryPoint, { ...state, isLoaded: true, isPending: false });
        }

        case ActionType.UPDATE_DELIVERY_POINT_PROPERTY: {
            const deliveryPoint: Partial<DeliveryPoint> = {
                [action.payload.propertyName]: action.payload.propertyValue
            };

            return deliveryPointAdapter.updateOne(
                {
                    id: action.payload.deliveryPointId,
                    changes: deliveryPoint
                },
                state
            );
        }

        default:
            return state;
    }
}
